module.exports = __webpack_public_path__ + "img/left-long.7eb37614.svg";